import script from "./videoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./videoCard.vue?vue&type=script&setup=true&lang=js"

import "./videoCard.vue?vue&type=style&index=0&id=65870a82&scoped=true&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65870a82"]])

export default __exports__